import React from 'react'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="gear" color="success" title="Alarm FTP Upload">
        <EuiText>
          <p>
            To use the video FTP Upload, you first have to set your ftp server address and login credentials.E.g.you can use your routers FTP service as FTP Server - in this case simply put in your routers IP as the FTP Server address.If you set up a FTP server on a local PC(for example with Filezilla Server), use the PC’s local IP address.
          </p>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox

